module.exports = "/_next/static/images/9bdfaeba77ddfc84dfe5ca4f1e3b085a-savings-waitlist-promise-3b-xs-1x.jpg";